import axiosInstance from "./utils";
import store from "../store";

export default {
  getSpots(clientId, parkingId) {
    return axiosInstance
      .get(`spots/${clientId}/${parkingId}`)
      .then((response) => response.data)
      .catch((err) => {
        store.dispatch("add_error_queue", {
          error: err,
          message: "Une erreur est survenu lors de l'appel des places",
        });
      });
  },

  createSpot(clientId, data) {
    return axiosInstance
      .post(`spots/${clientId}`, data)
      .then((response) => response.data)
      .catch((err) => {
        console.error("Error on create spot", err);
        store.dispatch("add_error_queue", {
          error: err,
          message: "Une erreur est survenu lors de la création de la place",
        });
      });
  },

  updateSpot(clientId, data) {
    return axiosInstance
      .put(`spots/${clientId}/${data.id}`, data)
      .then((response) => response.data)
      .catch((err) => {
        console.error("Error on update spot", err);
        store.dispatch("add_error_queue", {
          error: err,
          message: "Une erreur est survenu lors de la modification de la place",
        });
      });
  },

  deleteSpot(clientId, data) {
    return axiosInstance
      .delete(`spots/${clientId}/${data.id}`)
      .then((response) => response.data)
      .catch((err) => {
        console.error("Error on delete spot", err);
        store.dispatch("add_error_queue", {
          error: err,
          message: "Une erreur est survenu lors de la suppression de la place",
        });
      });
  },
};
